import { Box, type BoxProps } from '@frontend/components';

export type ItemAndDropBorderContainerProps = BoxProps;

export const ItemAndDropBorderContainer = ({
  position = 'relative',
  ...restProps
}: ItemAndDropBorderContainerProps) => {
  return <Box {...restProps} position={position} />;
};
